<div class="text-left">
    <p-dropdown
      [options]="options"
      [(ngModel)]="selectedOption"
      (onChange)="onChange($event)"
      [placeholder]="placeHolderText"
    >
    </p-dropdown>
  </div>
  